import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, User, Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const Account = () => {
  const { toast } = useToast();
  const [mode, setMode] = useState('login');
  const [showPass, setShowPass] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', name: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: mode === 'login' ? 'Conectare reușită' : 'Cont creat',
      description: mode === 'login' ? 'Bine ai revenit la AXA!' : 'Bine ai venit la AXA!',
    });
  };

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-neutral-50 border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 py-3 text-sm flex items-center gap-2 text-neutral-500">
          <Link to="/" className="hover:text-amber-600 flex items-center gap-1">
            <Home className="w-3.5 h-3.5" /> Acasă
          </Link>
          <span>/</span>
          <span className="text-neutral-900">Contul meu</span>
        </div>
      </div>
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="bg-white border border-neutral-200 rounded-2xl p-8 shadow-sm">
          <div className="text-center mb-6">
            <div className="w-14 h-14 mx-auto rounded-full bg-amber-100 flex items-center justify-center">
              <User className="w-7 h-7 text-amber-600" />
            </div>
            <h1 className="text-2xl font-serif font-bold text-neutral-900 mt-3">
              {mode === 'login' ? 'Conectare' : 'Cont nou'}
            </h1>
            <p className="text-sm text-neutral-500 mt-1">
              {mode === 'login' ? 'Intră în contul tău AXA' : 'Creează un cont în doar câteva secunde'}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === 'register' && (
              <div>
                <label className="block text-xs font-medium text-neutral-700 mb-1">Nume complet *</label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
                  <input
                    required
                    type="text"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full pl-10 pr-4 py-2.5 border border-neutral-300 focus:border-amber-500 outline-none rounded-lg text-sm"
                  />
                </div>
              </div>
            )}
            <div>
              <label className="block text-xs font-medium text-neutral-700 mb-1">Nume utilizator sau adresă email *</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
                <input
                  required
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full pl-10 pr-4 py-2.5 border border-neutral-300 focus:border-amber-500 outline-none rounded-lg text-sm"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-neutral-700 mb-1">Parola *</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
                <input
                  required
                  type={showPass ? 'text' : 'password'}
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  className="w-full pl-10 pr-10 py-2.5 border border-neutral-300 focus:border-amber-500 outline-none rounded-lg text-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-neutral-700"
                >
                  {showPass ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {mode === 'login' && (
              <div className="flex items-center justify-between text-xs">
                <label className="inline-flex items-center gap-2 text-neutral-600">
                  <input type="checkbox" className="accent-amber-500" /> Ține-mă minte
                </label>
                <a href="#" className="text-amber-700 hover:underline">
                  Ți-ai pierdut parola?
                </a>
              </div>
            )}

            <button type="submit" className="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 rounded-full transition-colors">
              {mode === 'login' ? 'Log in' : 'Creează cont'}
            </button>
          </form>

          <p className="text-center text-sm text-neutral-600 mt-6">
            {mode === 'login' ? 'Nu există încă un cont?' : 'Ai deja un cont?'}{' '}
            <button
              onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
              className="text-amber-700 font-medium hover:underline"
            >
              {mode === 'login' ? 'Creați un cont' : 'Conectați-vă'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Account;
